import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export const LoadingComponent: React.FC = () => {
  return (
    <Container fluid>
      <Row>
        <Col xs={12} className="text-center">
          <h2>
            <p>Please standby while initializing the app...</p>
          </h2>
        </Col>
      </Row>
    </Container>
  );
};
